module.exports = __webpack_public_path__ + "assets/images/alpha.31fecbe72666cd40d19814a130f23afc.png";